import React from 'react';
import StoryHighlights from '../components/StoryHighlights';
import HeroBanner from '../components/HeroBanner';
import MarketingOfferBanner from '../components/MarketingOfferBanner';
import LiveRatesSection from '../components/LiveRatesSection';
import RatePriceChart from '../components/RatePriceChart';
import CategoryGrid from '../components/CategoryGrid';
import ProductCatalog from '../components/ProductCatalog';
import TrustSection from '../components/TrustSection';
import Testimonials from '../components/Testimonials';
import StoreLocatorSection from '../components/StoreLocatorSection';

export default function HomePage() {
  return (
    <>
      {/* 1. Mobile-first Luxury Story Highlights */}
      <StoryHighlights />

      {/* 2. Hero Banner with Flipkart styling and Jewellery Background */}
      <HeroBanner />

      {/* 3. Today's Special Jewellery Offer Promotional Banner */}
      <MarketingOfferBanner />

      {/* 4. LIVE GOLD & SILVER RATES (24K, 22K, 18K, Silver 999) */}
      <LiveRatesSection />

      {/* 5. Gold & Silver Interactive Price Chart (1D, 1W, 1M, 3M, 6M, 1Y) */}
      <RatePriceChart />

      {/* 6. Shop By Category */}
      <CategoryGrid />

      {/* 7. Featured Jewellery, New Arrivals, Best Sellers & Special Offers */}
      <ProductCatalog />

      {/* 8. Why Choose Us / Hallmark Trust Guarantee */}
      <TrustSection />

      {/* 9. Customer & Bride Testimonials */}
      <Testimonials />

      {/* 10. Store Location & Flagship Showroom */}
      <StoreLocatorSection />
    </>
  );
}
